// import React, { createContext, useContext, useState, useEffect } from "react";

// const TenantContext = createContext();


// export const TenantProvider = ({ children }) => {
//     const [selectedTenant, setSelectedTenant] = useState(null);

//     // Load saved tenant from localStorage on app start
//     useEffect(() => {
//         const storedTenant = localStorage.getItem("selectedTenant");
//         if (storedTenant) {
//             setSelectedTenant(JSON.parse(storedTenant));
//         }
//     }, []);

//     // Save tenant to localStorage whenever it changes
//     const changeTenant = (tenant) => {
//         setSelectedTenant(tenant);
//         localStorage.setItem("selectedTenant", JSON.stringify(tenant));
//     };

//     return (
//         <TenantContext.Provider value={{ selectedTenant, setSelectedTenant }}>
//             {children}
//         </TenantContext.Provider>
//     );
// };

// //  Custom Hook for accessing the Tenant Context
// export const useTenant = () => useContext(TenantContext);

// 21 03 oncesi

// context/TenantContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import config from '../config/config';

const TenantContext = createContext();

export const TenantProvider = ({ children }) => {
  const [tenants, setTenants] = useState([]);
  const [selectedTenant, setSelectedTenant] = useState(null);

  const fetchTenants = async () => {
    try {
      const token = localStorage.getItem("userToken");
      const response = await axios.get(`${config.API_BASE_URL}/api/orchestrator/tenants`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // Server returns tenants directly as an array or inside a property
      const tenantData = response.data.tenants || response.data;

      if (Array.isArray(tenantData) && tenantData.length) {
        setTenants(tenantData);
      }
    } catch (error) {
      console.error("❌ Global fetchTenants failed:", error);
    }
  };

  useEffect(() => {
    fetchTenants(); // load on app start
  }, []);

  const changeTenant = (tenant) => {
    setSelectedTenant(tenant);
    localStorage.setItem("selectedTenant", JSON.stringify(tenant));
  };

  return (
    <TenantContext.Provider
      value={{
        selectedTenant,
        setSelectedTenant,
        tenants,
        fetchTenants,
      }}
    >

      {children}
    </TenantContext.Provider>
  );
};

export const useTenant = () => useContext(TenantContext);
